// extracted by mini-css-extract-plugin
module.exports = {"pathNodeSvg":"PathNode_pathNodeSvg__rqD5X","header":"PathNode_header__6tfLy","label":"PathNode_label__U_zSM"};